module.exports = __webpack_public_path__ + "img/cloth_g1_shirt_08.71a9345e.svg";